export default __webpack_public_path__ + "static/sl-studio-image-58eb8e95843f816ba1bf66fe38cfaf26.png";